import { ErrorCode as u } from "@ancon/wildcat-types";
import { isAxiosError as d } from "axios";
function f(s, e) {
  var t, a, n, o, r, i;
  const p = Object.values(u);
  return e != null ? Array.isArray(e) ? d(s) && typeof ((a = (t = s.response) == null ? void 0 : t.data) == null ? void 0 : a.errorCode) == "string" && e.includes((n = s.response) == null ? void 0 : n.data.errorCode) : f(s) && ((o = s.response) == null ? void 0 : o.data.errorCode) === e : d(s) && typeof ((i = (r = s.response) == null ? void 0 : r.data) == null ? void 0 : i.errorCode) == "string" && p.includes(s.response.data.errorCode);
}
export {
  f as default
};
